import { appSettings } from '../settings';

export const debug = appSettings.DeveloperMode
  ? console.log.bind(globalThis.console)
  : () => {
      /**/
    };
